import { Box } from '@primer/react';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const mainAction = actions.thongKe.crm;

const ThongKeCRMByChienDich = () => {
    const { statusChienDich, chienDichs } = useSelector((x: RootState) => x.thongKe.crm)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(mainAction.LOAD_BY_CHIEN_DICH_START({
            nam_hoc,
            dm_coso_id
        }))

    }, [nam_hoc, dm_coso_id])


    // Chuẩn bị dữ liệu cho Bar Chart
    const data = {
        labels: chienDichs.map(item => item.name), // Nhãn các môn học
        datasets: [
            {
                label: '',
                data: chienDichs.map(item => item.count), // Điểm tương ứng
                backgroundColor: '#006BFF', // Màu cột
                borderColor: '#006BFF', // Viền cột
                borderWidth: 1,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
            },
        ],
    };
    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: '',
            },
            datalabels: {
                color: 'black', // Màu chữ trắng
                anchor: 'end',
                align: 'start',
                offset: -20,
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
    };
    return (
        <>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Dữ liệu theo chiến dịch</Box>
            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Tổng số dữ liệu thu thập theo từng chiến dịch</Box>
            <Box sx={{
                height: "400px",
                width: "100%",
            }}>
                <Bar data={data} options={options} style={{
                    // width: "100%",
                    // height: "auto"
                    // height: "200px"
                }} />
            </Box>

        </>
    );
};

export default ThongKeCRMByChienDich;